import { render, staticRenderFns } from "./autocomplete-shop-category.vue?vue&type=template&id=a381d75e&"
import script from "./autocomplete-shop-category.vue?vue&type=script&lang=js&"
export * from "./autocomplete-shop-category.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports